import './style.scss'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

class CheckoutCheckbox extends PureComponent {
    render() {
        const { checked, disabled, onChange, children } = this.props
        return (
            <label className="checkbox">
                <input type="checkbox" checked={checked} disabled={disabled} onChange={onChange} />
                <span className="checkbox__checkbox" />
                {children}
            </label>
        )
    }
}

CheckoutCheckbox.propTypes = {
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
}

export default CheckoutCheckbox
